module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-video-banner grid grid__home"
  }, [_c('div', {
    staticClass: "home-video-banner--wrap"
  }, [(_vm.video) ? _c('div', {
    staticClass: "home-video-banner--root"
  }, [_c('img', {
    staticClass: "home-video-banner--img",
    attrs: {
      "src": _vm.video.poster.url,
      "alt": _vm.video.poster.alt
    }
  }), _vm._v(" "), (_vm.isMobile) ? _c('video', {
    key: "mobile-video",
    staticClass: "home-video-banner--video",
    attrs: {
      "autoplay": "",
      "loop": "",
      "muted": "",
      "playsinline": "",
      "poster": _vm.video.poster.url,
      "title": _vm.video.poster.alt
    },
    domProps: {
      "muted": true
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.video.url
    }
  })]) : _c('video', {
    key: "video",
    staticClass: "home-video-banner--video",
    attrs: {
      "autoplay": "",
      "loop": "",
      "muted": "",
      "playsinline": "",
      "poster": _vm.video.poster.url,
      "title": _vm.video.poster.alt
    },
    domProps: {
      "muted": true
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.video.url
    }
  })])]) : _c('div', {
    staticClass: "home-video-banner--root"
  }, [_c('img', {
    staticClass: "home-video-banner--image",
    attrs: {
      "src": _vm.content.image.url,
      "alt": _vm.content.image.alt
    }
  })])]), _vm._v(" "), _c(_vm.contentElementType, _vm._b({
    tag: "component",
    staticClass: "u-reset home-video-banner--content",
    class: _vm.contentClasses
  }, 'component', _vm.linkProps, false), [_c('div', {
    staticClass: "home-video-banner--container grid--container"
  }, [(_vm.content.title) ? _c('h1', {
    staticClass: "u-reset home-video-banner--title",
    class: _vm.content.hide_title ? 'home-video-banner--title__is-hidden' : '',
    domProps: {
      "innerHTML": _vm._s(_vm.content.title)
    }
  }) : _vm._e()])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-586e7c7a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-586e7c7a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sib-website/assets/src/js/app/vue/components/cms-plugins/home-video-banner/index.vue
// module id = 548
// module chunks = 7